export function stringEquals(a: string | undefined, b: string | undefined): boolean {
  return a?.toLocaleLowerCase() === b?.toLocaleLowerCase();
}

export function arrayContainsString(array: string[], s: string): boolean {
  if (!array || s == undefined) {
    return false;
  }

  for (const element of array) {
    if (stringEquals(element, s)) {
      return true;
    }
  }

  return false;
}
